<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar title="Aprovar relatório técnico"></basic-toolbar>
          <v-card-text>

            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <!-- Dialog de confirmação -->
                <v-dialog v-model="dialog" width="540">
                  <v-card>
                    <v-card-title class="headline grey lighten-2" primary-title>
                      Confirma a aprovação do relatório técnico?
                    </v-card-title>
                    <v-card-text>

                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-btn color="primary" text @click="dialog = false">Não</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="aprovar">Sim</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                
                <!-- Título -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12 sm11>
                    <c-readonly-field label='Título' :value="this.relatorio.tituloAcaoExtensao"></c-readonly-field>
                  </v-flex>
                </v-layout>

                <!-- Número -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12 sm11>
                    <c-readonly-field label='Número' :value="this.relatorio.numeroAcaoExtensao"></c-readonly-field>
                  </v-flex>
                </v-layout>

                <!-- Coordenador -->
                <v-layout row>
                  <v-flex xs12>
                    <c-readonly-field v-if="this.relatorio.nomeCoordenador !== null" label="Coordenador" :value="this.relatorio.nomeCoordenador"></c-readonly-field>
                    <c-readonly-field v-else label="Coordenador" value="-"></c-readonly-field>
                  </v-flex>
                </v-layout>

                <!-- Relatório-->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12 sm11>
                    <c-readonly-field label='Relatório' :value="'Relatório Técnico de Extensão ' + relatorio.ordem"></c-readonly-field>
                  </v-flex>
                </v-layout>

                <!-- Tipo do relatório-->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12 sm11>
                    <c-readonly-field
                      v-if="relatorio.tipoRelatorioTecnicoItem === 1"
                      label="Tipo do relatório"
                      value="Relatório Parcial: Deverá ser apresentado a cada 12 meses de atividade e encaminhado à ProEx no prazo máximo de 60 dias após o término do interstício."
                      ></c-readonly-field>

                      <c-readonly-field
                      v-if="relatorio.tipoRelatorioTecnicoItem === 2"
                      label="Tipo do relatório"
                      value="Relatório Parcial com Renovação: Deverá ser apresentado no prazo máximo de até 60 dias do último interstício da ação indicando o período de renovação."
                      ></c-readonly-field>

                      <c-readonly-field
                      v-if="relatorio.tipoRelatorioTecnicoItem === 3"
                      label="Tipo do relatório"
                      value="Relatório Final: Deverá ser apresentado no prazo máximo de até 60 dias após a data prevista de conclusão da ação extensionista ou do término das atividades, no caso de encerramento antes do previsto."
                      ></c-readonly-field>

                      <c-readonly-field
                      v-if="!relatorio.tipoRelatorioTecnicoItem"
                      label="Tipo do relatório"
                      value="-"
                      ></c-readonly-field>
                  </v-flex>
                </v-layout>

                <!-- Período a que se refere o relatório -->
                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <label>Período a que se refere o relatório</label>
                  </v-flex>
                </v-layout>
                <v-layout row wrap justify-space-between>
                  <v-flex md5 xs12 >
                    <c-readonly-field label="Início:" :value="relatorio.dtInicialFormatada"></c-readonly-field>
                  </v-flex>
                  <v-flex md1></v-flex>
                  <v-flex md5 xs12>
                    <c-readonly-field label="Fim:" :value="relatorio.dtFinalFormatada"></c-readonly-field>
                  </v-flex>
                  <v-flex md1></v-flex>
                </v-layout>

                <!-- Data de aprovação pela Câmara de Extensão -->
                <v-layout row wrap>
                  <v-flex xs11 sm5>
                    <c-date-menu
                      label="Data de aprovação pela Câmara de Extensão*"
                      v-model="aprovacao.dataAprovacaoRelatorioExtensao"
                      required
                      :rules="regrasBasicas"
                    >
                    </c-date-menu>
                  </v-flex>
                  <v-spacer></v-spacer>
                </v-layout>

                <!-- Processo -->
                <v-layout row wrap>
                  <v-flex xs11 sm5>
                    <v-text-field 
                      label="Processo*" 
                      v-model="aprovacao.processo" 
                      :rules="regrasBasicas"
                      prepend-icon="feed"
                      >
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <!-- Justificativa / Observação -->
                <v-layout row wrap>
                  <v-flex xs12>
                    <c-textarea :rows="2" :auto-grow="true" multi-line counter="2000"
                    label="Justificativa / Observação" v-model="aprovacao.justificativaObservacao"></c-textarea>
                  </v-flex>
                </v-layout>

                <br>

                <v-divider></v-divider>

                <v-card-actions>

                  <!-- Botão "Cancelar" -->
                  <v-btn color="primary" text @click="cancelar">Cancelar</v-btn>

                  <v-spacer></v-spacer>

                  <!-- Botão "Aprovar" -->
                  <v-btn color="primary" text @click="dialog = true" :disabled="!formularioValido">Aprovar</v-btn>

                </v-card-actions>

              </v-container>
            </v-form>

          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import DataMenu from '@/components/c-date-menu'
import TextArea from '@/components/c-textarea'
import ReadonlyField from '@/components/c-readonly-field'
import projetos from '@/utils/projetos'
import dates from '@/utils/dates'
import { mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'idRelatorio'],
  data: () => ({
    dialog: false,
    relatorio: {},
    aprovacao: {},
    observacao: '',
    formularioValido: false,
    regrasBasicas: [
      (input) => !!input || 'Este campo é obrigatório'
    ]
  }),
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    cancelar: function () {
      this.$router.go(-1)
    },
    aprovar: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando relatório de extensão.' })
      projetos.postAprovarRelatorio(this.idProjeto, this.idRelatorio, this.aprovacao)
      .then(response => {
        this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        this.$router.push({name: 'RelatoriosProjeto', params: {idProjeto: this.idProjeto}})
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
        this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        this.dialog = false
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Aprovando relatório de extensão.' })
      })
    }
  },
  mounted () {
    // Carrega o relatório.
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' })
    projetos.getRelatorioExtensao(this.idProjeto, this.idRelatorio)
    .then(response => {
      this.relatorio = response.data
      this.relatorio.dtInicialFormatada = dates.format(this.relatorio.dtInicial)
      this.relatorio.dtFinalFormatada = dates.format(this.relatorio.dtFinal)
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
      this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando relatório de extensão.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-date-menu': DataMenu,
    'c-textarea': TextArea,
    'c-readonly-field': ReadonlyField
  }
}
</script>



// WEBPACK FOOTER //
// aprovar.vue?558c280f